<template>
  <div class="sales">
    <div class="title">摩征会员服务协议</div>
    <div class="section">
      <br/>
      <p><strong>特别提示：</strong></p>
      <p>本协议系由宗申·比亚乔佛山摩托车企业有限公司（以下简称为“我司”）与所
有使用摩征会员服务的主体（包括但不限于个人、团队等）（以下简称“用户”）
对摩征会员服务的使用及相关服务所订立的有效合约。为使用摩征会员服务（简
称为：本服务），请您仔细阅读、理解并遵守《摩征会员服务协议》（简称为：本
协议）。本协议由您与摩征会员服务协议提供方共同缔结，具有合同效力。<strong>协议
中存在相关免除或限制责任的相应条款（以下称“免责条款”）、对用户权利进行
限制的条款（以下称“限制条款”）、约定争议解决方式和司法管辖的条款。前述，
该等免责、限制及争议解决方式和管辖条款可能以黑体加粗、颜色标记或其他合
理方式提示您注意，并请您重点阅读，您对该等条款的确认将可能导致您在特定
情况下的被动、不便、损失，请您在确认同意本协议之前或在使用我司会员服务
协议之前再次阅读前述条款。</strong></p>
<br/>
      <p>一、 定义</p>
      <p>智能付费会员：指根据宗申•比亚乔佛山摩托车企业有限公司的收费标准已支付
相应费用后获取的特色会员服务及会员权益资格的会员。</p>
<p><strong>摩征软件：摩征软件是我司拥有软件著作权的软件，摩征产品中有些产品或服务
是以收费方式提供的，您需要购买或充值后才能使用，请您在下单前，仔细确认
所购的会员种类、服务名称、价格、数量、有效期等订单信息。
协议更新：由我司可以对本协议下服务条款进行更新（包含变更、增加、减少相
应的条款内容），一旦服务条款发生更新，我司会通过系统提示、信息推送和／
或您在我方平台留下的联系方式通知和提醒您注意。如果您不同意变更后的协
议，可以停止对本服务的使用。您继续使用由我司提供的服务，则视为您已经接
受本协议的全部修改。</strong></p>
<br/>
      <p>二、 使用规范</p>
      <p>1、您申请开通智能付费会员服务时，需要您首先进行车主认证，提交您车辆的
行驶证、车架号、发票等信息和您本人姓名、身份证号码、手机号码等个人资料，
并保证您提供的个人资料真实、准确、完整、合法有效，如有变动，您应及时更
新，如您提供的资料不合法、不真实、不准确、不详尽，由此引起的损失及法律
责任将由您自行承担，一经发现并查实，摩征团队有权不经通知采取包括不限于
限期改正、限制或暂停使用、删除信息、冻结或注销账户并终止对您提供部分或
全部服务等措施。您如给宗申•比亚乔佛山摩托车企业有限公司造成任何损失的，
宗申•比亚乔佛山摩托车企业有限公司保留有权要求您赔偿的权利。</p>
      <p><strong>2、智能会员服务有效期，自您成功支付会员服务费用之日起算。若您希望在有
效期届满后继续享受会员服务，则需要在有效期届满后重新进行续费。</strong></p>
<br/>
      <p>三、 会员服务内容</p>
      <p>智能会员服务权益说明</p>
      <p>1、权益介绍：车辆定位、行程轨迹、智能体检、电子围栏、一键寻车、告警通
知；智能会员仅对当前选择开通的智能车辆（一辆）有效，用户账号下的其他绑
定车辆不受此影响，无相关智能会员服务。</p>
<p>2、参与车型：宗申 aprilia SR Max250、宗申比亚乔 X7 车型。</p>
<p>3、开通方式：登录摩征 app——进入爱车界面——添加车辆——绑定 IMEI——
智能服务——购买/续费——支付成功——提供发票；</p>
<p>4、虚拟产品</p>
<p><strong>基于虚拟产品的性质和特征，您所获取的虚拟产品不能够进行退货、换货、兑换
现金，亦不得用于商业领域，如买卖、置换、抵押等。为了保证您的用户权益，
请您通过官方渠 道购买会员产品，一切通 过非 官方 公布渠道取得的虚 拟产品及
其衍生服务均不获保护，我司有权中止或终止对您的服务；由此带来的损失，我
司不承担相关责任。</strong></p>
<p><strong>5、设备及系统差异</strong></p>
<p><strong>您通过我司指定渠道开通本服务后，可能会由于您使用的软件版本、设备、操作
系统等不同以及其他第 三方原 因等导致您实 际可使用的具体服务有差别，由此
可能给您带来的不便，您表示理解，您不予追究或者豁免我司的相关责任。</strong></p>
<p><strong>6、支付：</strong></p>
<p><strong>6.1 您应该通过我司指定的包括但不限于支付宝支付、微信支付等方式等现有方
式或今后我司指定方式，依约支付。支付完成后，不可进行转让或退款。除非因
摩征产品技术原因，导致您购买时被 重复 扣款 或因摩 征产 品技术原因导致您无
法享有购买的服务时，您可提出退款申诉，经过我司核实后可为您办理退款，但
您需要提供相应信息并配合我司处理。</strong></p>
<p><strong>6.2 您理解并认可，如果您通过第 三方支付工具在我方平台账户支付或充值后
可能产生的任何 商业风 险（包括但不限于不法分 子利用您账户 或银行卡等有价
卡等进行违法活动，第三方代为充值后再退款导致您的会员权益无法实现；采用
第三方黑产渠道代为充值，或通过第 三方非正规渠道购 买远 低于市 场价值的我
司会员权益等），该等风险均有可能给您造成相应的经济损失，我方在充分履行
其在本协议项下义务和符合 法律 规定的前提下，在法律有明确规定的情况和范
围内，承担相应的责任。</strong></p>
<p><strong>7、服务期限</strong></p>
<p>7.1 服务有效期：在有效期内续费，服务期将自动顺延，不会与当前有效期重叠。
请您理解。</p>
<p><strong>7.2 由于互联网服务的特殊性，为向您提供优质服务，我司须不定时进行服务器
的维修、调整、升级等，且在黑客攻击、计算机病毒侵入、监管机构政策通知等
不可抗力事件发生后，我司须解决故障并处理相关侵权事宜，因此您接受，本服
务的服务期限包含，我司解决故障、服务器维修、调整、升级、因第三方侵权处
理等所需的合理时间，我司对上述情况所需用的时间不另行补偿。</strong></p>
<br/>
      <p>四、 服务的变更、中止及终止</p>
      <p>4.1 本服务的中止或终止包含如下情况：</p>
      <p>4.1.1 用户主动中止或终止，包括但不限于会员到期未进行续费等；</p>
      <p>4.1.2 因为用户违约行为，我司主动中止或终止服务的；</p>
      <p>4.1.3 因国家或相关部门要求或发生不可抗力事件时，我司中止或终止服务的；</p>
      <p>4.1.4 其他根据法律法规或我司业务调整等应当或者需要中止或终止服务的。</p>
      <p>4.2<strong>中止或终止服务后，我司将尽最大努力通过合理方式通知用户。当您发现无
法登录或享受服务时，可以咨询我们的在线客服。</strong></p>
      <p><strong>4.3 中止或终止后的处理:</strong></p>
      <p><strong>4.3.1 除 法律 规定的责任外，我 司对本服务的中止或终 止对用户和任何第三人
不承担任何责任；</strong></p>
      <p><strong>4.3.2 除法律规定或本协议另有约定外，已收取的费用不予退还；</strong></p>
      <p><strong>4.3.3 正在进行的平台交易，我司将根据情况合理判断，是否继续进行或终止相
关交易，并视情况决定是否进行退费或扣除相关费用作为违约金；</strong></p>
      <p><strong>4.4 我司依据本协议的约定变更服务内容、服务方式以及本协议内容的，如果会
员不同意我 司的变更，有权选 择取消并 停止使用已经获取的对应的全 部或部 分
服务；如果会员继续使用摩征提供的上述服务，则视为会员已经接受摩征的上述
调整。</strong></p>
      <p><strong>4.5 会员如果不同意条款的修改，可主动向我司提出终止会员服务，但我司不退
还自 开通会员服务至提出终止会员服务所在月的 已享 受会员服务的部 分费 用；
如果会员继续享用会员服务，则视为会员已经接受条款的修改。</strong></p>
      <p><strong>4.6 您同意，由于互联网服务的特殊性，我司有权基于合法理由，修改、变更、
中断或终止部分或全部服务（统称“变更行为”）。在某些紧急情况下，我司无法
事先向您发出通知，故我司保留采取前述变更行为而不需通知您的权利，我司承
诺会在紧急情况解除后发布相关情况的说明。并且您同意，由于变更行为而造成
的任何损失，我司无需对您对或任何第三人承担任何责任。</strong></p>
      <p><strong>4.7 我司尽最大可能保障所展示商品或服务价格的准确性，但由于系统故障、市
场 因素等各种因素可能导致价格波动 变化，因上述原因造成商品或服务价格波
动变化，我司不对商品或服务的降价或促销提供任何价格保护或退款，您放弃因
此产生的价格差异申诉权利。</strong></p>
<br/>
      <p>五、 违约责任</p>
      <p>5.1 您在使用本服务的过程中，不得进行以下违约行为：</p>
      <p>5.1.1 违反本条款约定的；</p>
      <p>5.1.2 违反法律、法规、规章、条例以及任何具有法律效力之规范规定的；</p>
      <p>5.1.3 破坏、影响我司公司对任何第三方提供本服务；</p>
      <p>5.1.4 进行危害计算机网络安全的行为；</p>
      <p><strong>对我司及关联第三方（包括授权方和合作方）提供的本条款服务、活动造成不良
影响，侵犯及/或关联第三方我司公司及/或其他用户的正当利益；</strong></p>
      <p>5.1.5 被有权机构认定侵犯任何第三方的合法权益的；</p>
      <p>5.1.6 利用本服务获取非法利益的，包括但不限于通过转售、转让、转授权等行
为不正当牟利；</p>
      <p>5.1.7 其他侵犯我司合法利益的行为；</p>
      <p>5.1.8 利用摩征技术漏洞或者使用第三方软件等作弊手段影响摩征软件运行，以
及对摩征系统运行产生威胁的；</p>
      <p>5.2 违约行为及处理</p>
      <p><strong>您确认并同意，如果我司发现或收到他人举报您有违反本协议任何行为的，我司
有权依法进行独立判断并采取以下一项或多项措施处理：</strong></p>
      <p><strong>(1) 根据相应规则立即删除、屏蔽或断开相关的信息；</strong></p>
      <p><strong>(2) 采取包括但不限于中止或终止部分或全部本服务的措施；</strong></p>
      <p><strong>(3) 采取扣除违约行为发生时间内的会员权益时长的措施；</strong></p>
      <p><strong>(4) 我司无需向您退还任何费用，未使用的服务费用作为违约金归我司所有，您
的相关会员权益的损失由您自行承 担，我 司在 法律有明确规定的情况下承 担相
应的责任。</strong></p>
      <p><strong>(5) 因用户作弊利 用技 术漏 洞或者使 用第 三方软件等作弊手段影 响摩 征运行 ，
以及对摩 征系 统运行产生威 胁的 ，摩 征有 权采取 任何措施包括但不限于封 禁账
户、删除文件等方式，保护其自身权益；</strong></p>
      <p>5.3 赔偿责任</p>
      <p><strong>如您的行为使我司及/或其关联公司遭受损失（包括自身的直接经济损失、商誉
损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔
偿我司及/或其关联公司的上述全部损失。</strong></p>
      <p><strong>如您的行为使我 司及/或其关联公司遭受第三人 主张权利，我 司及/或其关联公
司可在对第三人承担金钱给付等义务后就全部损失向您追偿。</strong></p>
<br/>
      <p><strong>六、 免责声明</strong></p>
      <p><strong>6.1 您知悉并同意，用户在摩征平台上上传、发布或传输的内容，为用户的个人
行为，我司不对该等信息和内容的准确性、真实性、可用性、安全性、完整性和
正当性承担责任，您在此同意豁免追加我司的相关责任。</strong></p>
      <p><strong>6.2 您在进行相关信息及内容的使用、分享、下载等行为（“使用行为”）时，应
进 行独立判 断并合法使用，因您的使用行为造 成任何自身损害及 对第 三方的损
害，我司不承担任何责任。</strong></p>
      <p><strong>6.3 因电信和网通部门的通讯线路故障、网络或电脑故障、系统不稳定、不可抗
力（如服务器当机）等非我司原因造成您帐号、帐号内财产等丢失、减少的，您
无权要求我司承担补偿等责任</strong></p>
      <p><strong>6.4 您在使用摩征所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，
除法律有明确规定外，我司不承担任何责任。由于您将个人密码告知他人或与他
人共享注册帐户，由此导致的任何个人资料泄露，我司不承担任何责任。</strong></p>
      <p><strong>6.5 用户理解并同意，如用户在使用摩征过程中存在违规行为导致用户账号被封
禁，则用户无法继续使用（包括但不限于浏览、存储、同步、管理、分享和下载
等）摩征的所有服务，同时我司有权不予退还用户剩余会员权益等增值服务对应
的费用。</strong></p>
<br/>
      <p>七、 通知和送达</p>
      <p><strong>本协议项下宗申·比亚乔佛山摩托车企业对于用户所有的通知均可通过网页公
告、手机短信或常规的信件传送等方式进行，该等通知于发送之日视为已送达用
户。 为便于您收取相关通知，您应确保预留的联系方式为正确及有效，并在变
更后及时登录摩 征修 改， 如因您未提 供正确的联系信息或未及时 告知新的联系
方式，导致无法及时收取通知，将由您自行承担由此产生的损失及法律后果。我
司可通过上述方式之一或其中若干向您 送达 各类通知，而此类通知的内容或将
对您产生重大有利或不利影响，请您务必确保联系方式为有效并请及时关注。</strong></p>
<br/>
      <p>八、法律的适用和管辖</p>
      <p>8.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
      <p><strong>8.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协
商不成时，任何一方均可向宗申·比亚乔佛山摩托车企业所在地有管辖权的人民
法院提起诉讼。</strong></p>
      <p>8.3 我司未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之
放弃。</p>
      <p>8.4 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本
协议的其余条款仍应有效并且有约束力。</p>
      <p><strong>8.5 在法律法规允许的范围内，我司有权对本协议进行解释。</strong></p>
      <br/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  components: {},
  props: {},
  created () {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="less">
.sales{
  width: 100%;
  margin: 0 auto;
  .title{
    color: #000;
    font-size: 22px;
    text-align: center;
    font-weight: bold;
    font-family: '宋体';
    padding-left: 10px;
    padding-top: 16px;
  }
  .section{
    font-size: 16px;
    line-height: 20px;
    font-family: '宋体';
    padding: 0 10px;
    p{
      margin: 0;
    }
    .bold{
      font-weight: bold;
    }
    .ul{
       li{
        position: relative;
        padding-left: 20px;
       }
      .num{
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>
